import { faDoorClosed, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AverbacaoInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useRef, useState } from "react";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../components/Components";
import { getUuidV4, goToFocus } from "../../../utils/utils";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { RootState } from "../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import { addAvervacao, removeAvervacao, removeAvervacaoTodos } from "../../../features/manifestoSlice";

interface formProps {
    id: number | string;
    show: boolean;
    handleClose: () => void;
}

const Averbacao: React.FC<formProps> = ({ id, show, handleClose }) => {
    const [numero, setNumero] = useState<string>('');
    const numeroRef = useRef<HTMLInputElement>(null);
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { confirm, ConfirmModal } = useQuestion();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const manifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const dispatch = useDispatch();

    const validaPreenchimento = () => {
        if (numero.trim() === "") {
            goToFocus(numeroRef);
            alertModal('Informe o número da avebação');
            return false;
        }

        if (manifesto.seg.filter(item => item.id.toString() === id.toString())
            .flatMap(item => item.nAver).find((item: AverbacaoInterface) => item.nAver === numero.trim())) {
            goToFocus(numeroRef);
            alertModal('Número da avebação já foi adicionado.');
            return false;
        }
        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addAvervacao({ seguro_id: id.toString(), nAver: { id: getUuidV4(), nAver: numero.trim() } }))
            setNumero('');
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            if (manifesto.seg.filter(item => item.id.toString() === id.toString())
                .flatMap(item => item.nAver).length > 0) {
                dispatch(removeAvervacao({ seguro_id: id.toString(), id: value.id.toString() }))
            }
        }
        setSelecionado('');
    }

    const removerTudo = async () => {
        if (manifesto.seg.filter(item => item.id.toString() === id.toString())
            .flatMap(item => item.nAver).length > 0) {
            const confirmed = await confirm({
                message: <>Remover todas as averbações ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeAvervacaoTodos({ seguro_id: id.toString() }))
            }
        }
    }

    return (<Modal show={show} onHide={handleClose} centered backdrop='static' >
        <Modal.Header closeButton className="py-1">
            <Modal.Title >
                Averbações
            </Modal.Title>

        </Modal.Header>
        <Modal.Body>
            <Row className="mb-2 g-2">
                <Col md>
                    <Form.Group controlId="seg-averb-numero">
                        <Form.Label>Número da averbação</Form.Label>
                        <div className="input-group">
                            <Form.Control maxLength={40} value={numero}
                                ref={numeroRef} name="numero"

                                placeholder="Digite o número + [Enter] para adicionar"
                                onKeyUp={(e) => {
                                    if (e.key === 'Enter') {
                                        handleAdd();
                                    }
                                }}
                                onChange={(e) => setNumero(e.target.value)} />
                        </div>
                    </Form.Group>
                </Col>
            </Row>

            <JTable>
                <JTHead>
                    <tr>
                        <th className="text-center" style={{ width: '2.5rem' }}>
                            <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                        </th>
                        <th>Número da averbação</th>
                    </tr>
                </JTHead>
                <JTBody>
                    {manifesto.seg.filter(item => item.id.toString() === id.toString())
                        .flatMap(item => item.nAver).map((item: AverbacaoInterface) => (
                            <tr key={item.id}
                                className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center">
                                    <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.nAver })} />
                                </td>
                                <td>{item.nAver}</td>
                            </tr>
                        ))}
                </JTBody>
            </JTable>
        </Modal.Body>
        <Modal.Footer className="py-1">
            <Button variant="secondary" onClick={handleClose} >
                <FontAwesomeIcon icon={faDoorClosed} /> Fechar
            </Button>
        </Modal.Footer>
        {ModalMessageEl}
        {ConfirmModal}
    </Modal>)
}
export default Averbacao;
